import { unlockScroll } from './util/common';
import { newModalFromString } from './components/modal';

const popupPrivacyPolicyListener = () => {
    $('body').on('click', '.privacy-policy-short-marketing', function (e) {
        if ($('.privacy-policy-marketing-popup').length === 0) {
            e.preventDefault();
            $('.newsletter-popup').addClass('hidden');
            const htmlContent = $('.js-modal-privacy-policy-marketing').html();
            var tabContent = $('.js-content-privacy-policy-marketing').html();

            const onPopupClose = () => {
                unlockScroll();
            };
            if ($('.privacy-policy-marketing-popup').length > 0) {
                return;
            }

            // create and open confirmation modal
            const modal = newModalFromString(htmlContent, false, ['privacy-policy-marketing-popup'], null, onPopupClose);
            modal.open();
            modal.setContent(tabContent);
            $(modal.modalBox)
                .find('.close-button-privacy')
                .on('click', function (e) {
                    modal.close();
                    $('.newsletter-popup').removeClass('hidden');
                });

            if (('.modal-newsletter').length >= 0) {
                $('.go-back-newsletter-modal').removeClass('hidden');
                $('.js-backstepOnePointTwo-closeNewsletterModal').addClass('show-for-medium');
            }
        }
    });

    $('body').on('click', '.privacy-policy-short-profiling', function (e) {
        if ($('.privacy-policy-profiling-popup').length === 0) {
            e.preventDefault();
            $('.newsletter-popup').addClass('hidden');
            const htmlContent = $('.js-modal-privacy-policy-profiling').html();
            var tabContent = $('.js-content-privacy-policy-profiling').html();

            const onPopupClose = () => {
                unlockScroll();
            };
            if ($('.privacy-policy-profiling-popup').length > 0) {
                return;
            }
            // create and open confirmation modal
            const modal = newModalFromString(htmlContent, false, ['privacy-policy-profiling-popup'], null, onPopupClose);

            modal.open();
            modal.setContent(tabContent);
            $(modal.modalBox)
                .find('.close-button-privacy')
                .on('click', function (e) {
                    modal.close();
                    $('.newsletter-popup').removeClass('hidden');
                });

            if (('.modal-newsletter').length >= 0) {
                $('.go-back-newsletter-modal').removeClass('hidden');
                $('.js-backstepOnePointTwo-closeNewsletterModal').addClass('show-for-medium');
            }
        }
    });
    $('body').on('click', '.privacy-policy-short-marketing-modal', function (e) {
        e.preventDefault();
        let url = $(e.currentTarget).data('url');
        if (!url) {
            console.error('Missing URL for AJAX call');
            return;
        }
        $.ajax(url).then(data => {
            const onPopupClose = () => {
                unlockScroll();
            };
            // create and open confirmation modal
            const modal = newModalFromString(data, false, ['privacy-policy-marketing-popup'], null, onPopupClose);
            modal.open();
            $(modal.modalBox)
                .find('.close-button-privacy')
                .on('click', function (e) {
                    modal.close();
                });
        });
    });

    $('body').on('click', '.privacy-policy-short-profiling-modal', function (e) {
        e.preventDefault();
        let url = $(e.currentTarget).data('url');
        if (!url) {
            console.error('Missing URL for AJAX call');
            return;
        }
        $.ajax(url).then(data => {
            const onPopupClose = () => {
                unlockScroll();
            };
            // create and open confirmation modal
            const modal = newModalFromString(data, false, ['privacy-policy-profiling-popup'], null, onPopupClose);
            modal.open();
            $(modal.modalBox)
                .find('.close-button-privacy')
                .on('click', function (e) {
                    modal.close();
                });
        });
    });

    $('body').on('click', '.eco-info', function (e) {
        e.preventDefault();
        const htmlContent = $('.js-modal-privacy-policy-profiling').html();
        var tabContent = $('.js-content-eco-info').html();

        const onPopupClose = () => {
            unlockScroll();
        };

        // create and open confirmation modal
        const modal = newModalFromString(htmlContent, false, ['eco-popup'], null, onPopupClose);

        modal.open();
        modal.setContent(tabContent);
        $(modal.modalBox)
            .find('.close-button-eco')
            .on('click', function (e) {
                modal.close();
            });
    });
};

export {
    popupPrivacyPolicyListener
};
